// [1] User 관련 액션 타입
export const REQUEST_LOGIN = 'user/REQUEST_LOGIN' as const;
export const REQUEST_LOGIN_SUCCESS = 'user/REQUEST_LOGIN_SUCCESS' as const;
export const REQUEST_LOGIN_FAILURE = 'user/REQUEST_LOGIN_FAILURE' as const;

export const REQUEST_LOGOUT = 'user/REQUEST_LOGOUT' as const;
export const REQUEST_LOGOUT_SUCCESS = 'user/REQUEST_LOGOUT_SUCCESS' as const;
export const REQUEST_LOGOUT_FAILURE = 'user/REQUEST_LOGOUT_FAILURE' as const;

export const REQUEST_AUTHENTICATION = 'user/REQUEST_AUTHENTICATION' as const;
export const REQUEST_AUTHENTICATION_SUCCESS = 'user/REQUEST_AUTHENTICATION_SUCCESS' as const;
export const REQUEST_AUTHENTICATION_FAILURE = 'user/REQUEST_AUTHENTICATION_FAILURE' as const;

/**
 * Storage
 */
export const REQUEST_STORAGE_LIST = 'storage/REQUEST_STORAGE_LIST' as const;
export const REQUEST_STORAGE_LIST_SUCCESS = 'storage/REQUEST_STORAGE_LIST_SUCCESS' as const;
export const REQUEST_STORAGE_LIST_FAILURE = 'storage/REQUEST_STORAGE_LIST_FAILURE' as const;

/**
 * Category
 */
export const REQUEST_CATEGORY_LIST = 'category/REQUEST_CATEGORY_LIST' as const;
export const REQUEST_CATEGORY_LIST_SUCCESS = 'category/REQUEST_CATEGORY_LIST_SUCCESS' as const;
export const REQUEST_CATEGORY_LIST_FAILURE = 'category/REQUEST_CATEGORY_LIST_FAILURE' as const;

/**
 * Library Notification
 */
export const ADD_WAITING_LIBRARY_JOB_ID = 'library/ADD_WAITING_LIBRARY_JOB_ID' as const;
export const DELETE_WAITING_LIBRARY_JOB_ID = 'library/DELETE_WAITING_LIBRARY_JOB_ID' as const;
export const COMPARE_JOB_STATUS_AFTER_REQUEST_LIBRARY_LIST =
  'library/COMPARE_JOB_STATUS_AFTER_REQUEST_LIBRARY_LIST' as const;

export const REQUEST_SCRIPT_LIST = 'script/REQUEST_SCRIPT_LIST' as const;
export const REQUEST_SCRIPT_LIST_SUCCESS = 'script/REQUEST_SCRIPT_LIST_SUCCESS' as const;
export const REQUEST_SCRIPT_LIST_FAILURE = 'script/REQUEST_SCRIPT_LIST_FAILURE' as const;

export const REQUEST_PUT_SCRIPT = 'script/REQUEST_PUT_SCRIPT' as const;
export const REQUEST_PUT_SCRIPT_SUCCESS = 'script/REQUEST_PUT_SCRIPT_SUCCESS' as const;
export const REQUEST_PUT_SCRIPT_FAILURE = 'script/REQUEST_PUT_SCRIPT_FAILURE' as const;

export const REQUEST_SCRIPT_LIST_BY_SCROLL = 'script/REQUEST_SCRIPT_LIST_BY_SCROLL' as const;
export const REQUEST_SCRIPT_LIST_BY_SCROLL_SUCCESS =
  'script/REQUEST_SCRIPT_LIST_BY_SCROLL_SUCCESS' as const;
export const REQUEST_SCRIPT_LIST_BY_SCROLL_FAILURE =
  'script/REQUEST_SCRIPT_LIST_BY_SCROLL_FAILURE' as const;

export const SELECT_SCRIPT = 'script/SELECT_SCRIPT' as const;

export const REQUEST_WKBL_SCRIPT_LIST = 'wkbl/REQUEST_WKBL_SCRIPT_LIST' as const;
export const REQUEST_WKBL_SCRIPT_LIST_SUCCESS = 'wkbl/REQUEST_WKBL_SCRIPT_LIST_SUCCESS' as const;
export const REQUEST_WKBL_SCRIPT_LIST_FAILURE = 'wkbl/REQUEST_WKBL_SCRIPT_LIST_FAILURE' as const;

export const CLEAR_WKBL_SCRIPT_LIST = 'wkbl/CLEAR_WKBL_VIDEO_LIST' as const;

export const CHANGE_WKBL_SCRIPT_PAGE = 'wkbl/CHANGE_WKBL_SCRIPT_PAGE' as const;
export const CHANGE_WKBL_SCRIPT_SORT = 'wkbl/CHANGE_WKBL_SCRIPT_SORT' as const;
export const CHANGE_WKBL_SCRIPT_ASC = 'wkbl/CHANGE_WKBL_SCRIPT_ASC' as const;
export const CHANGE_WKBL_SCRIPT_RETURN_COUNT = 'wkbl/CHANGE_WKBL_SCRIPT_RETURN_COUNT' as const;

export const REQUEST_WKBL_VIDEO_LIST = 'wkbl/REQUEST_WKBL_VIDEO_LIST' as const;
export const REQUEST_WKBL_VIDEO_LIST_SUCCESS = 'wkbl/REQUEST_WKBL_VIDEO_LIST_SUCCESS' as const;
export const REQUEST_WKBL_VIDEO_LIST_FAILURE = 'wkbl/REQUEST_WKBL_VIDEO_LIST_FAILURE' as const;

export const CLEAR_WKBL_VIDEO_LIST = 'wkbl/CLEAR_WKBL_VIDEO_LIST' as const;

export const CHANGE_WKBL_VIDEO_SEASON = 'wkbl/CHANGE_WKBL_VIDEO_SEASON' as const;
export const CHANGE_WKBL_VIDEO_GAME_TYPE = 'wkbl/CHANGE_WKBL_VIDEO_GAME_TYPE' as const;
export const CHANGE_WKBL_VIDEO_GAME_DATE_FROM = 'wkbl/CHANGE_WKBL_VIDEO_GAME_DATE_FROM' as const;
export const CHANGE_WKBL_VIDEO_GAME_DATE_TO = 'wkbl/CHANGE_WKBL_VIDEO_GAME_DATE_TO' as const;

export const CHANGE_WKBL_VIDEO_PAGE = 'wkbl/CHANGE_WKBL_VIDEO_PAGE' as const;
export const CHANGE_WKBL_VIDEO_SORT = 'wkbl/CHANGE_WKBL_VIDEO_SORT' as const;
export const CHANGE_WKBL_VIDEO_ASC = 'wkbl/CHANGE_WKBL_VIDEO_ASC' as const;
export const CHANGE_WKBL_VIDEO_RETURN_COUNT = 'wkbl/CHANGE_WKBL_VIDEO_RETURN_COUNT' as const;

/**
 * WKBL VIDEO download status update
 */
export const ADD_DOWNLOADING_GROUP = 'wkbl/ADD_DOWNLOADING_GROUP' as const;
export const REMOVE_DOWNLOADING_GROUP = 'wkbl/REMOVE_DOWNLOADING_GROUP' as const;
export const UPDATE_DOWNLOADING_GROUP = 'wkbl/UPDATE_DOWNLOADING_GROUP' as const;
/**
 * WKBL Special VIDEO download status update
 */
export const ADD_DOWNLOADING_GROUP_SPECIAL = 'wkbl/ADD_DOWNLOADING_GROUP_SPECIAL' as const;
export const REMOVE_DOWNLOADING_GROUP_SPECIAL = 'wkbl/REMOVE_DOWNLOADING_GROUP_SPECIAL' as const;
export const UPDATE_DOWNLOADING_GROUP_SPECIAL = 'wkbl/UPDATE_DOWNLOADING_GROUP_SPECIAL' as const;

export const REQUEST_WKBL_SPECIAL_VIDEO_LIST = 'wkbl/REQUEST_WKBL_SPECIAL_VIDEO_LIST' as const;
export const REQUEST_WKBL_SPECIAL_VIDEO_LIST_SUCCESS =
  'wkbl/REQUEST_WKBL_SPECIAL_VIDEO_LIST_SUCCESS' as const;
export const REQUEST_WKBL_SPECIAL_VIDEO_LIST_FAILURE =
  'wkbl/REQUEST_WKBL_SPECIAL_VIDEO_LIST_FAILURE' as const;

export const CHANGE_WKBL_SPECIAL_VIDEO_PAGE = 'wkbl/CHANGE_WKBL_SPECIAL_VIDEO_PAGE' as const;
export const CHANGE_WKBL_SPECIAL_VIDEO_SORT = 'wkbl/CHANGE_WKBL_SPECIAL_VIDEO_SORT' as const;
export const CHANGE_WKBL_SPECIAL_VIDEO_ASC = 'wkbl/CHANGE_WKBL_SPECIAL_VIDEO_ASC' as const;
export const CHANGE_WKBL_SPECIAL_VIDEO_RETURN_COUNT =
  'wkbl/CHANGE_WKBL_SPECIAL_VIDEO_RETURN_COUNT' as const;

export const CLEAR_WKBL_SPECIAL_VIDEO_LIST = 'wkbl/CLEAR_WKBL_SPECIAL_VIDEO_LIST' as const;

export const REQUEST_CODE_LIST = 'code/REQUEST_CODE_LIST' as const;
export const REQUEST_CODE_LIST_SUCCESS = 'code/REQUEST_CODE_LIST_SUCCESS' as const;
export const REQUEST_CODE_LIST_FAILURE = 'code/REQUEST_CODE_LIST_FAILURE' as const;

export const REQUEST_PREFERENCE_LIST = 'preference/REQUEST_PREFERENCE_LIST' as const;
export const REQUEST_PREFERENCE_LIST_SUCCESS =
  'preference/REQUEST_PREFERENCE_LIST_SUCCESS' as const;
export const REQUEST_PREFERENCE_LIST_FAILURE =
  'preference/REQUEST_PREFERENCE_LIST_FAILURE' as const;

export const REQUEST_PREFERENCE_BY_BANNER = 'preference/REQUEST_PREFERENCE_BY_BANNER' as const;
export const REQUEST_PREFERENCE_BY_BANNER_SUCCESS =
  'preference/REQUEST_PREFERENCE_BY_BANNER_SUCCESS' as const;
export const REQUEST_PREFERENCE_BY_BANNER_FAILURE =
  'preference/REQUEST_PREFERENCE_BY_BANNER_FAILURE' as const;

export const REQUEST_TEAM_LIST = 'team/REQUEST_TEAM_LIST' as const;
export const REQUEST_TEAM_LIST_SUCCESS = 'team/REQUEST_TEAM_LIST_SUCCESS' as const;
export const REQUEST_TEAM_LIST_FAILURE = 'team/REQUEST_TEAM_LIST_FAILURE' as const;

export const REQUEST_CONFIG_LIST = 'config/REQUEST_CONFIG_LIST' as const;
export const REQUEST_CONFIG_LIST_SUCCESS = 'config/REQUEST_CONFIG_LIST_SUCCESS' as const;
export const REQUEST_CONFIG_LIST_FAILURE = 'config/REQUEST_CONFIG_LIST_FAILURE' as const;

export const OPEN_MODAL = 'modal/OPEN_MODAL' as const;
export const CLOSE_MODAL = 'modal/CLOSE_MODAL' as const;

export const CHANGE_VIDEO_CURRENT_TIME = 'video/CHANGE_VIDEO_CURRENT_TIME' as const;
export const CHANGE_VIDEO_DURATION = 'video/CHANGE_VIDEO_DURATION' as const;
export const CHANGE_VIDEO_IN_TIME = 'video/CHANGE_VIDEO_IN_TIME' as const;
export const CHANGE_VIDEO_OUT_TIME = 'video/CHANGE_VIDEO_OUT_TIME' as const;
export const INIT_VIDEO = 'video/INIT_VIDEO' as const;

export const THROW_ERROR = 'error/THROW_ERROR' as const;
export const CLEAR_ERROR = 'error/CLEAR_ERROR' as const;

export const ENQUEUE_SNACKBAR = 'notification/ENQUEUE_SNACKBAR' as const;
export const ENQUEUE_SNACKBAR_LIST = 'notification/ENQUEUE_SNACKBAR_LIST' as const;
export const CLOSE_SNACKBAR = 'notification/CLOSE_SNACKBAR' as const;
export const REMOVE_SNACKBAR = 'notification/REMOVE_SNACKBAR' as const;
